import { useAnimatedStyle } from 'react-native-reanimated';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
export const FONT_SIZE = rem(14);
const MIN_WIDTH = rem(90);
const usePriceChangeAnimatedStyle = (forStockShared, originalDataShared, originalXShared, amountShared) => {
    const colors = useColors();
    const priceChangeColorStyle = useAnimatedStyle(() => {
        const baseStyle = {
            fontFamily: 'Nunito-Regular',
            padding: 0,
            fontSize: FONT_SIZE,
            color: colors.text.secondary,
            minWidth: MIN_WIDTH,
        };
        if (forStockShared.value) {
            if (originalDataShared?.value &&
                'closePrices' in originalDataShared.value &&
                originalXShared &&
                originalXShared.value !== '') {
                const value = originalDataShared.value.closePrices[Math.round(originalXShared.value)];
                const openPrice = originalDataShared.value.closePrices[0];
                if (value !== undefined && openPrice !== undefined) {
                    if (value > openPrice)
                        baseStyle.color = colors.text.positive;
                    if (value < openPrice)
                        baseStyle.color = colors.text.negative;
                    return baseStyle;
                }
            }
            if (typeof amountShared.value !== 'number')
                return baseStyle;
            if (amountShared.value > 0)
                baseStyle.color = colors.text.positive;
            if (amountShared.value < 0)
                baseStyle.color = colors.text.negative;
            return baseStyle;
        }
        if (originalXShared &&
            originalXShared.value &&
            originalDataShared?.value &&
            'profitLoss' in originalDataShared.value) {
            const value = originalDataShared.value.profitLoss[originalXShared.value];
            const valueAlt = originalDataShared.value.profitLossPct[originalXShared.value];
            if (value !== undefined) {
                if (value > 0) {
                    baseStyle.color = colors.text.positive;
                }
                else if (value < 0) {
                    baseStyle.color = colors.text.negative;
                }
                else if (valueAlt > 0) {
                    baseStyle.color = colors.text.positive;
                }
                else if (valueAlt < 0) {
                    baseStyle.color = colors.text.negative;
                }
                return baseStyle;
            }
        }
        if (amountShared.value > 0)
            baseStyle.color = colors.text.positive;
        if (amountShared.value < 0)
            baseStyle.color = colors.text.negative;
        return baseStyle;
    }, [forStockShared, originalDataShared, originalXShared, amountShared, colors]);
    return priceChangeColorStyle;
};
export default usePriceChangeAnimatedStyle;
